module.exports = __webpack_public_path__ + "src/assets/textures/env/barn/barn_door_01_1k_bake.png";